import { render, staticRenderFns } from "./TwStepItem.vue?vue&type=template&id=5777252a&scoped=true&"
import script from "./TwStepItem.vue?vue&type=script&lang=js&"
export * from "./TwStepItem.vue?vue&type=script&lang=js&"
import style0 from "./TwStepItem.vue?vue&type=style&index=0&id=5777252a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777252a",
  null
  
)

export default component.exports